import Aura from '@primeng/themes/aura';
import { definePreset } from "@primeng/themes";

const paltaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#F9FDEB',
      100: '#F0FBC8',
      200: '#E5F8A4',
      300: '#D4F071',
      400: '#C3E94C',
      500: '#BCEA42', // base color
      600: '#A5D537',
      700: '#88B52A',
      800: '#6B8F22',
      900: '#536E1B',
      950: '#0E231C', // deep tone
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{gray.50}',
          100: '{gray.100}',
          200: '{gray.200}',
          300: '{gray.300}',
          400: '{gray.400}',
          500: '{gray.500}',
          600: '{gray.600}',
          700: '{gray.700}',
          800: '{gray.800}',
          900: '{gray.900}',
          950: '{gray.950}',
        },
        primary: {
          color: '{primary.700}',
          contrastColor: '#ffffff',
          hoverColor: '',
          activeColor: '#88B52A',
        },
        highlight: {
          background: '#FFFFFF',
          focusBackground: '#E9F4E2',
          color: '#0E231C',
          focusColor: '#0E231C',
        },
        text: {
          color: '#0E231C',
          hoverColor: '#1B3A2E',
          mutedColor: '#5C5C5C',
        },
        content: {
          background: '#FFFFFF',
          hoverBackground: '#F5F8F6',
          borderColor: '#E1EAE3',
          color: '#0E231C',
          hoverColor: '#1B3A2E',
        },
        formField: {
          background: '#FFFFFF',
          color: '#0E231C',
          placeholderColor: '#A3A3A3',
        },
        
      },
      dark: {
        surface: {
          0: '#0B1A15', // casi negro — fondo global
          50: '#0E231C', // base original
          100: '#123228',
          200: '#164033',
          300: '#1B4E3E',
          400: '#215D49',
          500: '#2A6B55',
          600: '#347A61',
          700: '#3E8A6E',
          800: '#499B7A',
          900: '#54AD87',
          950: '#60BF94', // tono más claro para bordes o elevaciones
        },
        primary: {
          color: '{primary.500}',
          contrastColor: '{primary.950}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.500}',
        },
        highlight: {
          background: '{primary.500}',
          color: '{primary.950}',
          focusBackground: '{primary.950}',
          focusColor: '{primary.50}',
        },
        formField: {
          background: '{surface.50}',
          hoverBorderColor: '{dark.surface.950}',
          placeholderColor: '{primary.50}',
          color: '{primary.50}',
          borderColor: '{gray.300}',
          iconColor: '{gray.300}',
          focusBorderColor: '{primary.500}',
          disabledColor: '{gray.400}',
          disabledBackground: '{dark.surface.0}',
          invalidBorderColor: '#FF5449',
          invalidPlaceholderColor: '#FF5449',
        },
        text: {
          color: '{primary.50}',
          hoverColor: '{primary.500}',
          mutedColor: '{primary.50}',
        },
        content: {
          background: '#0E231C',
          hoverBackground: '{dark.surface.500}',
          borderColor: '#1E3E31',
          color: '{primary.50}',
          hoverColor: '{primary.500}',
        },
        overlay: {
          select:{
            background:'{dark.surface.100}',
            color: '{primary.50}',
          },
          popover: {
            background: '{dark.surface.100}',
            color: '{primary.50}',
          },
          modal:{
            background: '{dark.surface.50}',
            color: '{primary.50}',
            
          },
        },
        list:{
          option:{
            color:'{primary.50}', 
            selectedFocusBackground: '{primary.400}',
            selectedFocusColor: '{primary.950}',   
          }
        },
        
       
      },
    },
  },
});

export default paltaPreset;
